import Fields from './fields';
import Widgets from './widgets';

export default {
  fields: Fields,
  widgets: Widgets,
  definitions: {},
  formContext: {}
};



// WEBPACK FOOTER //
// ./src/components/ui/semantic-form/registry.js